import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fechaLocalISO } from "@/lib/zona";
import { MESES, nombresTxt } from "@/lib/recordatorios";

const diaTxt = (iso) => { const [, m, d] = iso.split("-").map(Number); return `${d} de ${MESES[m - 1]}`; };

const TXT_G = {
  creado: () => "creaste el recordatorio.", editado: () => "cambiaste el recordatorio.", asociacion: () => "cambiaste con quién o con qué está relacionado.", pausar: () => "lo pausaste.", reanudar: () => "lo reanudaste.",
  terminar: () => "lo diste por terminado.", cancelar: () => "lo cancelaste.", reactivar: () => "lo volviste a activar.",
  fin_fecha: () => "terminó al llegar su fecha de fin.", papelera: () => "lo moviste a la papelera.", recuperar: () => "lo recuperaste de la papelera.",
  realizado_anticipado: (e) => `marcaste anticipadamente como realizado el aviso del ${diaTxt(e.aviso)}.`,
};

const txtOc = (o, h) => {
  const quien = nombresTxt((o.destinatarios || []).map((d) => d.nombre));
  const conCorreo = o.modo !== "aviso" && quien;
  switch (h.estado) {
    case "preparada": return conCorreo ? `AL DÍA preparó el correo para ${quien}.` : `AL DÍA te avisó del ${diaTxt(o.fecha)}.`;
    case "abierta": return `abriste el correo${quien ? ` para ${quien}` : ""} para revisarlo.`;
    case "pospuesta": return `lo aplazaste hasta el ${diaTxt(h.hasta)}.`;
    case "realizada": return `lo marcaste como realizado${conCorreo ? ` (${quien})` : ""}.`;
    case "omitida": return `decidiste omitirlo esta vez${conCorreo ? ` (${quien})` : ""}.`;
    default: return null;
  }
};

// Acontecimientos en lenguaje normal; las repeticiones seguidas (p. ej. varias aperturas) se agrupan.
export const eventos = (g, ocs) => {
  const out = [];
  (g.actividad || []).forEach((e) => { if (TXT_G[e.tipo]) out.push({ ts: e.fecha, txt: TXT_G[e.tipo](e), k: `g-${e.tipo}` }); });
  ocs.forEach((o) => {
    let prev = null;
    (o.historial || []).forEach((h) => {
      if (h.anticipado || h.estado === prev) return;
      prev = h.estado;
      const t = txtOc(o, h);
      if (t) out.push({ ts: h.fecha, txt: t, k: `${o.id}-${h.estado}` });
    });
  });
  return out.sort((a, b) => b.ts.localeCompare(a.ts));
};

export const Actividad = ({ g }) => {
  const [abierta, setAbierta] = useState(false);
  const [ocs, setOcs] = useState(null);
  useEffect(() => {
    if (!abierta) return undefined;
    const cargar = () => api.get(`/gestiones/${g.id}/ocurrencias`).then((r) => setOcs(r.data)).catch(() => setOcs([]));
    cargar();
    window.addEventListener("aldia-gestiones", cargar);
    return () => window.removeEventListener("aldia-gestiones", cargar);
  }, [abierta, g.id]);
  const lista = ocs ? eventos(g, ocs) : [];
  return (
    <section className="space-y-3" data-testid="rp-actividad">
      <button data-testid="rp-actividad-toggle" onClick={() => setAbierta(!abierta)} aria-expanded={abierta}
        className="w-full min-h-[56px] rounded-2xl bg-white border border-[#E5DFD5] text-lg font-semibold text-[#1C2421]">
        {abierta ? "Ocultar actividad anterior" : "Ver actividad anterior"}
      </button>
      {abierta && (ocs === null ? <p className="text-base text-[#6E7A74]">Cargando…</p> : !lista.length
        ? <p className="text-base text-[#6E7A74]" data-testid="rp-actividad-vacia">Todavía no hay actividad.</p>
        : (
          <ul className="bg-white border border-[#E5DFD5] rounded-2xl divide-y divide-[#F2EDE4]" data-testid="rp-actividad-lista">
            {lista.map((e, i) => (
              <li key={`${e.k}-${i}`} className="px-4 py-3 text-base text-[#1C2421]"><strong>{diaTxt(fechaLocalISO(e.ts))}:</strong> {e.txt}</li>
            ))}
          </ul>
        ))}
    </section>
  );
};
